import { Component, OnInit, HostListener,ElementRef } from '@angular/core';
import { element } from 'protractor';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  showVar: any;
  isShowDiv:boolean = true;
  showList: boolean = false;
  expand_url: string = "/assets/img/expand_pathway_desktop.png";
  collapse_url: string = "/assets/img/collapse_pathway_desktop.png";
  image_src: any = this.collapse_url;
  blurcount: any; 
  //let va = expand_url.includes("factor_XII_expand");
  //currentPosition: number = window.pageYOffset;
  @HostListener('window:scroll', ['$event.target']) // for window scroll events
  scroll(e:any) {
    let scroll = e.scrollingElement.scrollTop;
    //console.log("this is the scroll position", scroll)
    // if (scroll > this.currentPosition) {
    //   //console.log("scrollDown");
    //   document.getElementsByClassName('sec_header')[0].setAttribute("style", "position:fixed;")
    // } else 
    if (scroll > document.getElementById('sign-up').offsetTop) {
      document.getElementsByClassName('sec_header')[0].setAttribute("style", "position:absolute;");
    }
    else if (scroll <= document.getElementById('sec_header').offsetTop) {
      document.getElementsByClassName('sec_header')[0].setAttribute("style", "position:absolute;");
      document.getElementsByClassName('sec_header')[0].setAttribute("style", "top:auto;");
    }
    else{
      document.getElementsByClassName('sec_header')[0].setAttribute("style", "position:fixed;");
      document.getElementsByClassName('sec_header')[0].setAttribute("style", "top:0px;");

    }
    //this.currentPosition = scroll;
  }


  toggleImage() {
    this.showVar = !this.showVar;
    this.isShowDiv = !this.isShowDiv;
    this.showList = !this.showList;
    this.image_src = this.showVar ? this.expand_url : this.collapse_url;
    this.el.nativeElement.querySelectorAll('.img-pathway').forEach(element => {
      element.classList.add('img-blur');
    })
    setTimeout(() => {
      this.el.nativeElement.querySelectorAll('.img-pathway').forEach(element => {
        element.classList.remove('img-blur');
      })
    }, 1000);
  }
  constructor(private el : ElementRef) { }
  OnThankyouShow(){
    this.el.nativeElement.querySelector('#patient_home_page').style.top = '0px';
  }
  ngOnInit() {
 }

  ngAfterViewInit() {
    //***Your code here***
    
    // setTimeout(() => {
    //   this.blurcount = this.el.nativeElement.querySelectorAll('.blur-text').length;
    //   for(let i=0;i<this.blurcount;i++){
    //     document.querySelectorAll('.blur-text')[i].setAttribute("style", "filter: blur(0px);");
    //   }
    // }, 5000);
  }
  

}
